<template>
  <v-card
    class="ma-0 pa-3"
    height="342"
  >
    <v-container
      class="pa-0 d-flex justify-space-between align-center mb-5"
    >
      <v-card-text class="text-body-2 pa-0">{{ $t('customerAttractionMethod') }}</v-card-text>
      <!-- <v-select
        :items="items1"
        label="یک هفته گذشته"
        dense
        outlined
        append-icon="mdi-chevron-down"
      >
      </v-select> -->
      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="secondary"
            outlined
            v-bind="attrs"
            v-on="on"
            custom
          >
            <svg width="17" height="17" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6 8L3.5 5.5L4.2 4.775L5.5 6.075V2H6.5V6.075L7.8 4.775L8.5 5.5L6 8ZM3 10C2.725 10 2.48967 9.90217 2.294 9.7065C2.09833 9.51083 2.00033 9.27533 2 9V7.5H3V9H9V7.5H10V9C10 9.275 9.90217 9.5105 9.7065 9.7065C9.51083 9.9025 9.27533 10.0003 9 10H3Z" fill="#030303"/>
            </svg>
          </v-btn>
        </template>
        <v-list v-if="items != null && items != undefined && items.length > 0 && series.length > 0 && chartOptions.labels.length > 0 && $store.getters.getpermission && $store.getters.getpermission.includes('overview')">
          <v-list-item @click="exportChart('png')">
            <v-list-item-title>
              <v-card-text class="pa-0 text-body-2">{{ $t('PNG-image') }}</v-card-text>
            </v-list-item-title>
          </v-list-item>
          <v-list-item @click="exportChart('pdf')">
            <v-list-item-title>
              <v-card-text class="pa-0 text-body-2">{{ $t('PDF-file') }}</v-card-text>
            </v-list-item-title>
          </v-list-item>
          <v-list-item @click="exportChart('excel')">
            <v-list-item-title>
              <v-card-text class="pa-0 text-body-2">{{ $t('EXCEL-file') }}</v-card-text>
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-container>
    <v-container 
      v-if="$store.getters.getpermission && $store.getters.getpermission.includes('overview')"
      class="d-flex justify-center align-center pa-0"
    >
      <apexchart
        v-if="items != null && items != undefined && items.length > 0 && series.length > 0 && chartOptions.labels.length > 0"
        type="pie"
        width="350"
        :options="chartOptions"
        :series="series"
        ref="chartComponent"
      />
      <div
        v-if="items != null && items != undefined && items.length == 0 && !loading"
        style="margin-top: 50px;"
      >
        <div class="d-flex justify-center align-center">
          <img src="@/assets/dashboard/no-data(2).png" style="width: 120px;" />
        </div>
        <div class="d-flex justify-center align-center mt-5">
          <v-card-text class="pa-0 text-caption">
            {{ $t('there is no enough information for showing.') }}
          </v-card-text>
        </div>
      </div>
      <v-progress-circular
        v-if="loading"
        :width="3"
        color="blue"
        indeterminate
      />
    </v-container>
    <div v-else>
      <div
        style="margin-top: 50px;"
      >
        <div class="d-flex justify-center align-center">
          <img src="@/assets/dashboard/not-access(3).png" style="width: 120px;" />
        </div>
        <div class="d-flex justify-center align-center mt-5">
          <v-card-text class="pa-0 text-caption text-center">
            {{ $t("you don't have access to this information") }}
          </v-card-text>
        </div>
      </div>
    </div>
  </v-card>
  </template>

<script>
import jsPDF from "jspdf" // PDF export
import * as XLSX from "xlsx" // Excel export

export default {
  data () {
    return {
      items: [],
      series: [],
      loading: false,
      chartOptions: {
        chart: {
          width: 50,
          height: 50,
          type: 'pie',
          fontFamily: 'IRANSans',
          toolbar: {
            show: false,
            offsetX: 0,
            offsetY: 0,
            tools: {
              download: '<p>d</p>',
              selection: true,
              zoom: true,
              zoomin: true,
              zoomout: true,
              pan: true,
              reset: true | '<img src="/static/icons/reset.png" width="20">',
              customIcons: []
            },
            export: {
              scale: undefined,
              width: undefined,
              csv: {
                filename: undefined,
                columnDelimiter: ',',
                headerCategory: 'category',
                headerValue: 'value',
                categoryFormatter (x) {
                  return new Date(x).toDateString()
                },
                valueFormatter (y) {
                  return y
                }
              },
              svg: {
                filename: undefined
              },
              png: {
                filename: undefined
              }
            },
            autoSelected: 'zoom'
          }
        },
        labels: [],
        colors: [],
        legend: {
          position: 'top',
          horizontalAlign: 'center',
          fontSize: '12px',
          markers: {
            width: 12,
            height: 12,
            shape: 'square'
          },
          itemMargin: {
            horizontal: 5,
            vertical: 10
          },
          labels: {
            colors: []
          }
        },
        responsive: [{
          breakpoint: 480,
          options: {
            chart: {
            },
            legend: {
              position: 'top',
              horizontalAlign: 'center'
            }
          }
        }]
      }
    }
  },
  methods: {
    fetchMethods () {
      this.loading = true
      this.$axios.get(this.$endpoint + 'widgets', {
        params: {
          type: 'customerAttraction'
        }
      })
        .then(r => {
          this.loading = false
          this.items = r.data
          this.chartOptions.labels = this.items.map(item => item.key)
          this.series = this.items.map(item => item.value)
          // Generate colors for both the chart and the legend
          const colors = this.generateColors(this.items.length)
          // Assign the generated colors to the chart's colors and legend's label colors
          this.chartOptions.colors = colors
          this.chartOptions.legend.labels.colors = colors
        })
        .catch(e => {
          console.error('Error:', e)
        })
        .finally(() => {
        })
    },
    generateColors (length) {
      const baseColors = ['#0066ff', '#4caf50', '#ff5252', '#00CAE3', '#7C4DFF', '#FF9800', '#FF5252'] // Example color palette
      // Repeat or truncate the baseColors array to match the number of items dynamically
      return Array.from({ length }, (_, i) => baseColors[i % baseColors.length])
    },
    async exportChart(format) {
      const chartRef = this.$refs.chartComponent?.chart;
      if (!chartRef) {
        console.error("Chart instance not available.");
        return;
      }

      try {
        if (format === "png" || format === "svg") {
          const { imgURI } = await chartRef.dataURI(); // Get image data
          this.downloadImage(imgURI, `chart-export.${format}`);
        } else if (format === "pdf") {
          await this.exportToPDF();
        } else if (format === "excel") {
          this.exportToExcel();
        }
      } catch (error) {
        console.error("Export failed:", error);
      }
    },

    // 📌 Download PNG / SVG
    downloadImage(uri, filename) {
      const link = document.createElement("a");
      link.href = uri;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },

    // 📌 Export to PDF (using jsPDF)
    async exportToPDF() {
      const chartRef = this.$refs.chartComponent?.chart;
      if (!chartRef) return;

      const { imgURI } = await chartRef.dataURI(); // Get chart as image
      const pdf = new jsPDF(); // Create a new PDF
      pdf.addImage(imgURI, "PNG", 15, 40, 180, 120); // Add image to PDF
      pdf.save("chart-export.pdf"); // Save PDF
    },

    // 📌 Export to Excel (using XLSX)
    exportToExcel() {
      if (!Array.isArray(this.series) || this.series.length === 0 || !this.chartOptions.labels) {
        console.error("Chart series data is missing or incomplete.");
        return;
      }

      // Convert chart data to an array format
      const chartData = [
        [this.$t('customerAttractionMethod'), this.$t('value')], // Column Headers
        ...this.chartOptions.labels.map((label, index) => [label, this.series[index] ?? 0])
      ];

      const worksheet = XLSX.utils.aoa_to_sheet(chartData);
      const workbook = XLSX.utils.book_new();

      XLSX.utils.book_append_sheet(workbook, worksheet, "Chart Data");
      XLSX.writeFile(workbook, "chart-export.xlsx");
    }
  },
  mounted () {
    this.fetchMethods()
  }
}
</script>

<style scoped>
.v-sheet.v-card:not(.v-sheet--outlined) {
    box-shadow: none !important;
}
::v-deep .v-text-field.v-text-field--enclosed:not(.v-text-field--rounded) > .v-input__control > .v-input__slot {
    padding: 0 4px 0 0 !important;
}
::v-deep .v-text-field--outlined.v-input--dense.v-text-field--outlined > .v-input__control > .v-input__slot {
    min-height: 32px !important;
}
::v-deep .v-label.v-label {
    font-size: 11px !important;
}
::v-deep .v-icon.v-icon {
    font-size: 15px;
}
::v-deep .apexcharts-legend {
    padding: 0;
}
::v-deep .apexcharts-legend .apexcharts-legend-series {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
}
::v-deep .apexcharts-legend .apexcharts-legend-series:first-child {
    margin-right: 0 !important;
}
::v-deep .apexcharts-legend-marker {
    width: 12px !important;
    height: 12px !important;
    border-radius: 0 !important;
    margin-left: 3px !important;
}
</style>
